// extracted by mini-css-extract-plugin
module.exports = {"logo":"Logo_logo__1G5Yh","white":"Logo_white__2gjrA","black":"Logo_black__2Sdgt"};